import { NgModule }      from '@angular/core';
import { CommonModule }  from '@angular/common';
import { FormsModule} from '@angular/forms';
import { Routes, RouterModule }  from '@angular/router';



import {ContactUs} from "./contactus.page";

export const routes: Routes = [
    { path: 'contactus', component: ContactUs },
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        ContactUs
    ]
})

export class ContactusModule { }



// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/structure/contactus/contactus.module.ts